var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container pdf" }, [
    _c(
      "div",
      { staticClass: "common-header" },
      [
        _vm.isNomal
          ? _c("common-header", {
              attrs: {
                headerList: [
                  { label: "帮助文档", url: "/system/helpDoc/nomalHelpDoc" },
                  { label: "文件预览", url: "" }
                ]
              }
            })
          : _c("common-header", {
              attrs: {
                headerList: [
                  { label: "系统管理", url: "" },
                  { label: "帮助文档管理", url: "/system/helpDoc" },
                  { label: "文件预览", url: "" }
                ]
              }
            })
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.pdfloading,
            expression: "pdfloading"
          }
        ],
        staticClass: "pdf-right"
      },
      [
        _c("vue-pdf-app", {
          staticStyle: { height: "calc(100vh - 126px)" },
          attrs: {
            config: _vm.config,
            pdf: _vm.qsburl,
            "page-scale": "page-width"
          },
          on: { open: _vm.openHandler }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }